import { render } from "./shareButton.vue?vue&type=template&id=e404f52e&scoped=true&ts=true"
import script from "./shareButton.vue?vue&type=script&lang=ts"
export * from "./shareButton.vue?vue&type=script&lang=ts"

import "./shareButton.vue?vue&type=style&index=0&id=e404f52e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e404f52e"]])

export default __exports__